/** Returns the menu object id encoded in a cart entry URL path. */
export const getParentIdFromUrl = (url: string = ''): string => {
  if (!url) {
    return url;
  }

  const [pathWithParentId] = url.split('?');
  const parentIdIdx = pathWithParentId.lastIndexOf('/') + 1;

  return pathWithParentId.slice(parentIdIdx);
};
